export const buildSmartApplyProcedureUrlPath = (
  procId: string,
  orgSlug: string,
  customPath?: string,
): string => {
  if (customPath) {
    return `/${orgSlug}/smart-apply/apply-procedure-alias/${customPath}`;
  }
  return `/${orgSlug}/smart-apply/apply-procedure/${procId}`;
};
